/**
 * Selection bus — synchronizes open views without forcing graph navigation.
 * Selecting an entity updates subscribers; Sigma only reacts if a graph view is open.
 */

import { create } from 'zustand';
import type { EngineeringEntity, GraphViewId } from './types';

interface SelectionState {
  entity: EngineeringEntity | null;
  /** Secondary multi-select (e.g. authorized files) */
  relatedIds: string[];
  /** Which graph lens is currently mounted (null = no graph open) */
  openGraphView: GraphViewId | null;
  select: (entity: EngineeringEntity | null) => void;
  setRelated: (ids: string[]) => void;
  openGraph: (view: GraphViewId | null) => void;
  clear: () => void;
}

export const useSelectionStore = create<SelectionState>((set) => ({
  entity: null,
  relatedIds: [],
  openGraphView: null,

  select: (entity) => set({ entity }),

  setRelated: (relatedIds) => set({ relatedIds }),

  openGraph: (openGraphView) => set({ openGraphView }),

  clear: () => set({ entity: null, relatedIds: [], openGraphView: null }),
}));

/** Convenience: select + optional related without opening a graph */
export function selectEntity(entity: EngineeringEntity | null, relatedIds: string[] = []) {
  useSelectionStore.getState().select(entity);
  useSelectionStore.getState().setRelated(relatedIds);
}
